import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IItemForGetShortInfo, IGetCategoriesShort, IGetCategoriesShortResponse } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { getCategoriesShortInfo } from 'backend/categories';

interface ICategorySelect {
	setIDCategory: (value: Nullable<string>) => void;
	setFetchedCategories: (value: IItemForGetShortInfo[]) => void;
	changeLoaderStatus: (value: boolean) => void;
	IDsSelectedRestaurant: string[];
	initialIDSelectedCategory: Nullable<string>;
}

const CategorySelect: React.FC<ICategorySelect> = ({
	setIDCategory,
	setFetchedCategories,
	changeLoaderStatus,
	IDsSelectedRestaurant,
	initialIDSelectedCategory,
}) => {
	const [isFirstRender, setIsFirstRender] = useState<boolean>(true);
	const { response, loading, refetch, responseError } = useFetchData<
		IGetCategoriesShortResponse,
		IGetCategoriesShort
	>(IDsSelectedRestaurant.length ? getCategoriesShortInfo : null, { restaurantIds: IDsSelectedRestaurant });
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectCategory') }], [t]);

	useEffect(() => {
		refetch();
	}, [IDsSelectedRestaurant]);

	useEffect(() => {
		if (response) {
			setFetchedCategories(response.data.categories);
		}
	}, [response]);

	useEffect(() => {
		if (isFirstRender && response) {
			setIDCategory(initialIDSelectedCategory);
			changeLoaderStatus(false);
			setIsFirstRender(false);
		}
	}, [initialIDSelectedCategory, isFirstRender, response]);

	return (
		<FormSelect
			testId="CategorySelect"
			name="IDSelectedCategory"
			label="categoryLabel"
			options={response?.data.categories}
			fetchError={responseError}
			loading={loading}
			disabled={true}
			onRefetch={refetch}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(CategorySelect);
